/* unplugin-vue-components disabled */import script from "./ScreenModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenModal.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenModal.vue?vue&type=style&index=0&id=34a651e6&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a651e6"]])

export default __exports__